export const getDropDwonOptionApi = ( query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/console/get-constants/${queryString ? `?${queryString}` : ""}`;
};

export const addReportAnIssueApi = ( query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/console/report-bug/${queryString ? `?${queryString}` : ""}`;
};
